var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "span",
    [
      _vm.title
        ? _c("h6", {
            staticClass: "font-weight-normal mt-4",
            domProps: { innerHTML: _vm._s(_vm.title) },
          })
        : _vm._e(),
      _vm.items.length > 0
        ? _c(
            "div",
            { staticClass: "flex-container flex-column mb-0" },
            [
              _vm.includeDate === false
                ? _c(
                    "div",
                    { staticClass: "item-picker__list" },
                    _vm._l(_vm.orderedItems, function (item) {
                      return _c("DisplaySkillItem", {
                        key: item.id,
                        attrs: {
                          item: item,
                          itemProp: _vm.itemProp,
                          includeDate: _vm.includeDate,
                          tooltip: _vm.tooltip,
                        },
                      })
                    }),
                    1
                  )
                : _vm._e(),
              _vm.includeDate === true
                ? _vm._l(_vm.orderedItems, function (item) {
                    return _c("DisplaySkillItem", {
                      key: item.id,
                      attrs: {
                        item: item,
                        itemProp: _vm.itemProp,
                        includeDate: _vm.includeDate,
                        tooltip: _vm.tooltip,
                      },
                    })
                  })
                : _vm._e(),
            ],
            2
          )
        : _vm._e(),
      _c(
        "b-link",
        {
          staticClass: "d-inline-flex btn no-choices",
          attrs: { href: _vm.profileLink },
          on: { click: _vm.goToProfile },
        },
        [
          _c(
            "div",
            { staticClass: "fieldset-btn addfields" },
            [_c("b-icon", { attrs: { icon: "plus", "font-scale": "1" } })],
            1
          ),
          _c("span", [_vm._v(_vm._s(_vm.t.general_Add))]),
        ]
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }